export default __webpack_public_path__ + "static/media/FilterTable.3f943459.svg";